import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { getCookie } from "../../section/cookie";
import language from '../../nls/language.json';
import Context from "../../context/Context";

const SidebarLink = styled(Link)`
  display: flex;
  color: #4c4c4c;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  list-style: none;
  height: 60px;
  text-decoration: none;
  font-size: 16px;
  border-color: #4c4c4c;

  &:hover {
    border-left: 4px solid #4c4c4c;
    cursor: pointer;
  }
`;

const SidebarLabel = styled.span`
  margin-left: 16px;
`;

const DropdownLink = styled(Link)`
  color: #c9c6c6;
  height: 60px;
  padding: 0 1.2rem;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 14px;
  background: #313131;
  font-family: 'Oswald';

  &:hover {
    background: #8fc5cf;
    cursor: pointer;
    color: #0a6c7a;
  }
`;

const ShowNav = ({ permissionsRequired, children }) => {
  const permissions = getCookie("permissions");
  var rotePermissions = [];
  let validRole = false;

  if (permissionsRequired) {
    rotePermissions = permissionsRequired;
    validRole = rotePermissions.some((permission) =>
      permissions?.includes(permission)
    );
  } else {
    validRole = true;
  }
  if (validRole) {
    return children;
  }
  return;
};
const SubMenu = ({ item, mouseOver }) => {
  const [subnav, setSubnav] = useState(false);
  const showSubnav = () => setSubnav(!subnav);
  const { selectedCountry } = useContext(Context);

  useEffect(() => {
    if(!mouseOver) setSubnav(false);
  }, [mouseOver])

  return (
    <>
      <ShowNav permissionsRequired={item.permission}>
        <SidebarLink
          to={item.path}
          onClick={item.subNav && showSubnav}
        >
          <div>
            {item.icon}
            {(mouseOver || window.innerWidth < 767) && (
            <SidebarLabel className="sideBarText">
              {language[selectedCountry.name].SideBar[item.title]}
            </SidebarLabel>
            )}
          </div>
          {(mouseOver || window.innerWidth < 767) && (
            <div>
              {item.subNav && subnav
                ? item.iconOpened
                : item.subNav
                  ? item.iconClosed
                  : null}
            </div>
          )}
        </SidebarLink>
        {subnav &&
          item.subNav.map((item, index) => {
            return (
              <ShowNav
                permissionsRequired={item.permission}
                key={`${item.title}-${index}-subMenu`}
              >
                <DropdownLink
                  to={item.path}
                >
                  {item.icon}
                  <SidebarLabel>
                    {language[selectedCountry.name].SideBar[item.title]}
                  </SidebarLabel>
                </DropdownLink>
              </ShowNav>
            );
          })}
      </ShowNav>
    </>
  );
};

export default SubMenu;
